module.exports = __webpack_public_path__ + "img/gla-360-temp.76a9f198.png";